function Accordion(containerObject) {
	/* THIS FIX */
	var _this = this;

	/* PRIVATE CONSTANTS */

	/* PRIVATE VARIABLES */

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;


	/* PRIVATE FUNCTIONS */
	function _construct() {
		_this.container = containerObject;
		_this.init();
	}

	function onClickToogleContent() {
		var headline = $('p.headline', _this.container);
		var content = $('div.content', _this.container);
		headline.click(function () {
			headline.toggleClass('active');
			content.slideToggle({
				complete: function() {
					if(headline.hasClass('active')) {
						headline.attr('title', headline.data('labelCollapsed'));
					}else{
						headline.attr('title', headline.data('labelExpanded'));
					}
				},
				duration: 300
			});

		});
	}

	/* PUBLIC FUNCTIONS */
	this.init = function () {
		if (!_this.inited) {
			// init
			onClickToogleContent();

			_this.inited = true;
		}
	};


	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
